function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import List from '@mui/material/List';
import fonts from '../theme/fonts.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const StyledList = props => {
  const styles = {
    "&.MuiList-root": {
      fontFamily: fonts.type.medium,
      minWidth: 250
    },
    "&.MuiList-padding": {
      paddingBottom: 8
    },
    ...props.style
  };
  return /*#__PURE__*/React.createElement(List, _extends({}, props, {
    sx: styles
  }), props.children);
};
export default StyledList;